import React from "react";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import "./report.css"; // Custom CSS file for styling

const NumberCategoryChart = (props) => {
  debugger
  console.log(props?.data?.labels,'--------------')
  const backgroundColor= [
    "rgba(255, 184, 0, 1)",
    "rgba(216, 0, 0, 1)",
    "#0ebd0e",
    "rgba(60, 228, 225, 1)",
    "rgba(94, 149, 151, 1)",
    "#546e7a",
    "#663366",
    "#003333 ",
    "#330066",
    "#52595D",
    "#566D7E",
    "#29465B"
  ]
  const data = {
    labels: props?.data?.labels,
    datasets: [
      {
        data: props?.data?.data,
        backgroundColor: [
          "rgba(255, 184, 0, 1)",
          "rgba(216, 0, 0, 1)",
          "#0ebd0e",
          "rgba(60, 228, 225, 1)",
          "rgba(94, 149, 151, 1)",
          "#546e7a",
          "#663366",
          "#003333 ",
          "#330066",
          "#52595D",
          "#566D7E",
          "#29465B"
        ],
        hoverBackgroundColor: [
          "rgba(255, 184, 0, 1)",
          "rgba(216, 0, 0, 1)",
          "#0ebd0e",
          "rgba(60, 228, 225, 1)",
          "rgba(94, 149, 151, 1)",
          "#546e7a",
          "#663366",
          "#003333 ",
          "#330066",
          "#52595D",
          "#566D7E",
          "#29465B"
        ],
      },
    ],
  };

  const options = {
    cutout: "0%", // No hole in the center (full circle)
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: false,
        position: "right",
      },
      datalabels: {
        formatter: (value) => {
          return `${value}%`; // Display percentage values
        },
        color: "#FFF",
        font: {
          weight: "bold",
          size: 10, // Increased font size for better visibility
        },
        align: "center", // Align data labels to the center of the segment
        anchor: "center", // Anchor data labels to the center
        padding: 20, // Add padding to move the text higher and within the segment
      },
    },
  };

  return (
    <div className="ncr-tracker">
      <div className="chart-container">
        <Doughnut data={data} options={options} />
        <div className="chart-center">
          {/* Add total count or any central information if needed */}
        </div>
      </div>
      <div className="row mt-4" >
        {props?.data?.labels?.map((val,inx)=>
        <div className="chart-legend1 col-5">
        <div className="legend-item1">
          <div
            className="legend-color closed"
            style={{ backgroundColor: backgroundColor[inx] }}
          ></div>
          <span>{props?.data?.labels[inx]?props?.data?.labels[inx]:"N/A"}</span>
        </div>
      </div>)}
      </div>

      

      

      
    </div>
  );
};

export default NumberCategoryChart;
